import React from 'react';

const WORDS = [
  ['Pick', 'the winner'],
  ['Call', 'the method'],
  ['Talk', 'the trash'],
  ['Take', 'the belt'],
];

/** Outlined fight-poster marquee between sections. Decorative. */
export default function Ticker() {
  const run = (hidden) => (
    <div className="pnp-ticker-item" aria-hidden={hidden ? 'true' : undefined}>
      {WORDS.map(([a, b]) => (
        <React.Fragment key={a}>
          <span><em>{a}</em> {b}</span>
          <span className="pnp-ticker-slash" />
        </React.Fragment>
      ))}
    </div>
  );
  return (
    <div className="pnp-ticker" aria-hidden="true">
      <div className="pnp-ticker-track pnp-scroll-drift-none">
        {run(false)}
        {run(true)}
      </div>
    </div>
  );
}
